import { Component, OnInit, Input } from '@angular/core';
import { LoginUnawareComponent } from '../login-unaware-component';
import { GraphClientService } from '../services/graph-client-service';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

const CATEGORY_LEISURE = 'Leisure';
const CATEGORY_CORPORATE = 'Corporate';
const CATEGORY_TOURS = 'Tours';

/**
 * Displays a list of top sales performers sourced from a table inside an Excel document stored
 * in a SharePoint Online document library.
 */
@Component({
  selector: 'app-top-performers',
  templateUrl: './top-performers.component.html',
  styleUrls: ['./top-performers.component.scss']
})
export class TopPerformersComponent extends LoginUnawareComponent implements OnInit {
  @Input() public title: string;

  public leisurePerformers: any[];
  public corporatePerformers: any[];
  public toursPerformers: any[];

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService) {
    super(diagnosticsFactory.create('TopPerformersComponent'));
    this.leisurePerformers = [];
    this.corporatePerformers = [];
    this.toursPerformers = [];
  }

  ngOnInit() {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
        const dynamicData  = data as any;
        const allPerformers = dynamicData.text as any[];

        if (!allPerformers.length || allPerformers.length === 0) {
          this.diagnostics.logError(`Error parsing data returned from service call: no results.`);
        }

        for (let i = 0; i < allPerformers.length; ++i) {
          const item = allPerformers[i];
          const category = item[0];

          if (category === CATEGORY_LEISURE) {
            this.leisurePerformers.push(item);
          } else if (category === CATEGORY_CORPORATE) {
            this.corporatePerformers.push(item);
          } else if ( category === CATEGORY_TOURS) {
            this.toursPerformers.push(item);
          } else {
            this.diagnostics.logError(
              `Error parsing data returned from service call: unknown category '${ category }'.`);
          }
        }
      }, error => {
        this.diagnostics.logError(`Failed making the service call. Details: ${ error }`);
      });
  }
}
